import $store from '../store'
import * as authService from '../services/auth.service'
import { mapState, mapGetters } from 'vuex';
import $router from '../router'
import { TabPane } from 'element-ui';

/**
 * Current user state initialization
 * @WARN Must be always first in middleware chain
 */
export function initCurrentUserStateMiddleware (to, from, next) {
  var isLogin = $store.getters['user/isLogin'];
  if (!isLogin && to.name != 'login') {
      $router.push({ name: 'login' })
  } else return next();
  //const currentUserId = $store.state.user.currentUser.id
  /*
    1. call action getCurrent
    2. it's supposed to fail with HTTP 401
    3. set state 'login:false'
    4. redirect
  */
  //$store.dispatch('auth/getCurrent');
  
  //authService.getCurrentUser();
  //$store.dispatch();
  /** if (authService.getRefreshToken() && !currentUserId) {
    return authService.refreshTokens()
      .then(() => $store.dispatch('user/getCurrent'))
      .then(() => next())
      .catch(error => console.log(error))
  }
  next()*/
  
}

/**
 * Check access permission to auth routes
 */
export function checkAccessMiddleware (to, from, next) {
  
  return next();
  const currentUserId = $store.state.user.currentUser.id
  const isAuthRoute = to.matched.some(item => item.meta.isAuth)

  if (isAuthRoute && currentUserId) return next()
  if (isAuthRoute) return next({ name: 'login' })
  next()
}
export function samePageMiddleware(to, from, next) {
  return next();
}
export function setPageTitleMiddleware (to, from, next) {
  const pageTitle = to.matched.find(item => item.meta.title)

  if (pageTitle) window.document.title = pageTitle.meta.title
  next()
}
